import httpService from '../../http'
import api from '../../api'
import helpers from '../../helpers'
const apiModule = api.admins
const errorsStr = helpers.error.errors
const mapper = helpers.mapper

function getModel () {
  return {
    id: {
      data: 'id',
      title: 'ID',
      value: null,
      type: null,
      order: 'desc',
      showOrder: true
    },
    login: {
      data: 'login',
      title: 'Логин',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    comment: {
      data: 'comment',
      title: 'Комментарий',
      value: null,
      type: null
    }
  }
};

const state = {
  model: getModel(),
  id: null,
  show: 'all',
  question: getModel(),
  questions: [],
  errMain: null,
  errors: {
    login: null,
    passwordNew: null,
    passwordConfirm: null,
    passwordCurrent: null
  }
}
const getters = {
  getModel (state) { return state.model },
  getId (state) { return state.id },
  getShow (state) { return state.show },
  getOne (state) { return state.question },
  getAll (state) { return state.questions },
  getErrors (state) { return state.errors },
  getErrMain (state) { return state.errMain }
}
const mutations = {
  setModel (state, data) { state.model = data },
  setId (state, data) { state.id = data },
  setShow (state, data) { state.show = data },
  setOne (state, data) { state.question = data },
  setAll (state, data) { state.questions = data },
  setErrors (state, data) { state.errors[data.param] = data.value },
  setErrMain (state, data) { state.errMain = data },
  setOrder (state, data) {
    for (let param in state.model) {
      if (state.model[param].order && state.model[param].showOrder && state.model[param] != state.model[data.param]) state.model[param].order = null
    };
    let order = state.model[data.param].order
    if (!order) order = 'desc'
    else if (order == 'desc') order = 'asc'
    else if (order == 'asc') order = null
    state.model[data.param].order = order
  }
}
const actions = {
  setModelRequired ({ commit }, data) {
    commit('setModel', mapper.modelRequired(data.required, getModel()))
  },
  resetAllErr ({ state, commit }) {
    commit('setErrMain', null)
    let errors = state.errors
    for (let err in errors) {
      commit('setErrors', { param: err, value: null })
    };
  },
  sendErrMain ({ commit }, data) {
    console.log(data)
    commit('setErrMain', httpService.error(data))
  },
  toAdd ({ commit }) {
    commit('setId', null)
    commit('setShow', 'one')
  },
  toUpdate ({ commit }, data) {
    commit('setId', data.id)
    commit('setShow', 'one')
  },
  toAll ({ commit }) {
    commit('setId', null)
    commit('setShow', 'all')
    commit('setOne', getModel())
  },
  async getOne ({ state, commit, dispatch }, data) {
    try {
      dispatch('resetAllErr')
      if (state.id) {
        let result = await httpService.get(apiModule.admin.getOne, { id: state.id })
        commit('setOne', mapper.dataToView(data.required, getModel(), result.data.data))
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async getAll ({ state, commit, dispatch }, data) {
    try {
      let order = []
      let model = state.model
      for (let param in model) {
        if (model[param].order) order.push(`${model[param].data},${model[param].order}`)
      };
      data.params.order = order
      let result = await httpService.get(apiModule.admin.getAll, data.params)
      commit('setAll', result)
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async createOrUpdate ({ state, commit, dispatch }, data) {
    try {
      dispatch('resetAllErr')
      let dataNew = mapper.dataToRequest(data.data)
      if (!dataNew.login) commit('setErrors', { param: 'login', value: errorsStr.empty })
      if (!state.id && !data.passwordNew) commit('setErrors', { param: 'passwordNew', value: errorsStr.empty })
      if (!state.id && !data.passwordConfirm) commit('setErrors', { param: 'passwordConfirm', value: errorsStr.empty })
      if (data.passwordNew != data.passwordConfirm) {
        commit('setErrors', { param: 'passwordNew', value: errorsStr.notEqualPassword })
        commit('setErrors', { param: 'passwordConfirm', value: errorsStr.notEqualPassword })
      };
      if (state.id && !data.passwordCurrent) commit('setErrors', { param: 'passwordCurrent', value: errorsStr.empty })
      let isErr = false
      for (let error in state.errors) {
        if (state.errors[error]) isErr = true
      };
      if (!isErr) {
        let result = getModel()
        if (!state.id) {
          dataNew.password = data.passwordNew
          result = await httpService.post(apiModule.admin.add, dataNew)
        } else {
          if (data.passwordNew) dataNew.password = data.passwordNew
          dataNew.passwordCurrent = data.passwordCurrent
          result = await httpService.patch(apiModule.admin.update, dataNew)
        };
        commit('setId', result.data.data.id)
        commit('setOne', mapper.dataToView(data.required, getModel(), result.data.data))
        dispatch('resetAllErr')
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async delete ({ state, commit, dispatch }, data) {
    try {
      dispatch('resetAllErr')
      if (!data.passwordCurrent) commit('setErrors', { param: 'passwordCurrent', value: errorsStr.empty })
      let isErr = false
      for (let error in state.errors) {
        if (state.errors[error]) isErr = true
      };
      if (!isErr) {
        await httpService.delete(apiModule.admin.delete, { id: state.id, passwordCurrent: data.passwordCurrent })
        dispatch('toAll')
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
